import { Breadcrumb, Col, Row, Table } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { fetchDieToolById } from '../../slices/die-tool';
import '../../styles/Main.scss';
import moment from 'moment';


function DieLifeCard() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [dietool, setDietool] = useState(null);


  useEffect(() => {
    const fetchDieProfile = async () => {
      try {
        dispatch(fetchDieToolById(id))
          .unwrap()
          .then((response) => {
            if (response?.data) {
              setDietool(response?.data);
            }
          })
          .catch((error) => {
            console.error('');
          });
      } catch (error) {
        console.error('');
      }
    };
    fetchDieProfile();
  }, [id]);
  const dieLifeData = [
    {
      key: '1',
      property1: 'Profile No.',
      value1: dietool?.die?.die_number + '-' + dietool?.tool_number,
      property2: 'Die Size',
      value2: dietool?.die_size?.die_width + ' X ' + dietool?.die_size?.die_height,
      property3: 'Die Technician',
      value3A: 'B',
      value3B: '-',
      image: dietool?.die?.die_diagram,
    },
    {
      key: '2',
      property1: 'Profile Size (mm)',
      value1: [
        dietool?.die?.dimension1,
        dietool?.die?.dimension2,
        dietool?.die?.dimension3,
        dietool?.die?.dimension4,
      ]
        .filter(dim => dim !== null && dim !== '' && dim !== undefined)
        .map(dim => Number(dim).toFixed(2))
        .join(' X ') || 'N/A',
    
      property2: 'Serial No',
      value2: dietool?.tool_number,
      property3: 'Die Type',
      value3A: dietool?.die?.die_type,
      value3B: '-',
      image: '',
    },
    {
      key: '3',
      property1: 'Development Date',
      value1: dietool?.order_date ? moment(dietool.order_date).format('DD-MM-YYYY') : 'N/A',
      property2: 'No of Cavity',
      value2: dietool?.die_cavity,
      property3: 'Backer No',
      value3A: dietool?.backer_number,
      value3B: '-',
      image: '',
    },
    {
      key: '4',
      property1: 'Die Received Date',
      value1: dietool?.received_date?moment(dietool.received_date).format('DD-MM-YYYY'):'N/A',
      property2: 'Calculated WT (kg/m)',
      value2: dietool?.die?.wt_kg_p_mt,
      property3: 'Bolster Name',
      value3A: dietool ? dietool.eligible_bloster?.bloster_no : 'N/A',
      value3B: '-',
      image: '',
    },
    {
      key: '5',
      property1: 'Die Developer',
      value1: dietool?.developer?.customer_name,
      property2: 'Die Hardness (hrc)',
      value2: '',
      property3: 'Bolster Type',
      value3A: dietool?.eligible_bloster,
      value3B: '-',
      image: '',
    },
    {
      key: '6',
      property1: 'Eligible Press',
      value1: dietool?.eligible_for_press ? dietool?.eligible_for_press.name : 'N/A',
      property2: 'Developer Reference. No',
      value2: dietool?.developer_ref_no || 'N/A',
      property3: 'Insert',
      value3A: '-',
      value3B: '-',
      image: '',
    }
  ];

  const dieLifeColumns = [
    { dataIndex: 'property1', key: 'property1', render(text, record) { return { props: { style: { background: "#f7f7f7" } }, children: <div style={{ fontWeight: 'bold' }}>{text}</div> }; } },
    { dataIndex: 'value1', key: 'value1' },
    { dataIndex: 'property2', key: 'property2', render(text, record) { return { props: { style: { background: "#f7f7f7" } }, children: <div style={{ fontWeight: 'bold' }}>{text}</div> }; } },
    { dataIndex: 'value2', key: 'value2' },
    { dataIndex: 'property3', key: 'property3', render(text, record) { return { props: { style: { background: "#f7f7f7" } }, children: <div style={{ fontWeight: 'bold' }}>{text}</div> }; } },
    { dataIndex: 'value3B', key: 'value3B' },
    { dataIndex: 'value3A', key: 'value3A' },
    {
      dataIndex: 'image',
      key: 'image',
      render: (filePath, record, index) => {
        const rowSpan = index === 0 ? dieLifeData.length : 0;
        const fileExtension = filePath?.split('.').pop().toLowerCase();

        return {
          children: filePath ? (
            fileExtension === 'pdf' ? (
              <div style={{ textAlign: 'center' }}>
                <a
                  href={filePath}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'blue', textDecoration: 'underline' }}
                >
                  View PDF
                </a>
              </div>
            ) : (
              <div style={{ textAlign: 'center' }}>
                <img
                  src={filePath}
                  alt="Die Diagram"
                  style={{
                    width: '100px',
                    height: '100px',
                    objectFit: 'contain',
                  }}
                />
              </div>
            )
          ) : null,
          props: { rowSpan },
        };
      },
    },
  ];
  const nitridingColumns = [
    { title: 'No.', dataIndex: 'no', key: 'no' },
    { title: 'Date', dataIndex: 'date', key: 'date' },
    {
      title: 'Total Gross Prod.',
      dataIndex: 'totalGrossProd',
      key: 'totalGrossProd',
    },
    {
      title: 'Hardness Before Nitriding',
      dataIndex: 'hardnessBefore',
      key: 'hardnessBefore',
    },
    {
      title: 'Hardness After Nitriding',
      dataIndex: 'hardnessAfter',
      key: 'hardnessAfter',
    },
    { title: 'Remarks', dataIndex: 'remarks', key: 'remarks' },
  ];

  const nitridingData = [
    { key: '1', no: '1', date: '', totalGrossProd: '', hardnessBefore: '', hardnessAfter: '', remarks: '' },
    { key: '2', no: '2', date: '', totalGrossProd: '', hardnessBefore: '', hardnessAfter: '', remarks: '' },
    { key: '3', no: '3', date: '', totalGrossProd: '', hardnessBefore: '', hardnessAfter: '', remarks: '' },
    { key: '4', no: '4', date: '', totalGrossProd: '', hardnessBefore: '', hardnessAfter: '', remarks: '' },
    { key: '5', no: '5', date: '', totalGrossProd: '', hardnessBefore: '', hardnessAfter: '', remarks: '' },
  ];
  const extrusionColumns = [
    { title: 'S No.', dataIndex: 'sno', key: 'sno' },
    { title: 'Date', dataIndex: 'date', key: 'date' },
    {
      title: 'Extrusion Speed',
      dataIndex: 'extrusionSpeed',
      key: 'extrusionSpeed',
    },
    { title: 'Billet Grade', dataIndex: 'billetGrade', key: 'billetGrade' },
    { title: 'Temperature', dataIndex: 'temperature', key: 'temperature' },
    { title: 'Prod. Input (kg)', dataIndex: 'prodInput', key: 'prodInput' },
    { title: 'Prod. Output (kg)', dataIndex: 'prodOutput', key: 'prodOutput' },
    { title: 'Recovery (%)', dataIndex: 'recovery', key: 'recovery' },
    { title: 'Actual wt/m', dataIndex: 'actualWM', key: 'actualWM' },
    { title: 'Weight (%)', dataIndex: 'weight', key: 'weight' },
    {
      title: 'Correction Date',
      dataIndex: 'correctionDate',
      key: 'correctionDate',
    },
  ];

  const extrusionData = [
    {
      key: '1',
      sno: '1',
      date: '',
      extrusionSpeed: '',
      billetGrade: '',
      temperature: '',
      prodInput: '',
      prodOutput: '',
      recovery: '',
      actualWM: '',
      weight: '',
      correctionDate: '',
    },
    {
      key: '2',
      sno: '2',
      date: '',
      extrusionSpeed: '',
      billetGrade: '',
      temperature: '',
      prodInput: '',
      prodOutput: '',
      recovery: '',
      actualWM: '',
      weight: '',
      correctionDate: '',
    },
  ];

  return (
    <>
     <div className="sticyaction">
  <div className="pagenamerow mb-0">
          <h2>Die Life Card</h2>
          <div className="bredcrumbwrp">
              <Link to="/die-tool" className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/die-tool">Die Tools</Link> },
                  { title: 'Die Life Card' },
                ]}
              />
            </div>
        </div>
     </div>
     <div  className="formwrapper">
           
            <h4 className="main-title mb-3">Alux ERP</h4>
            <Table
              title={() => 'Die Life Card'}
              columns={dieLifeColumns}
              dataSource={dieLifeData}
              pagination={false}
              bordered
              className="custom-die-life-table px-0"
              showHeader={false}
            />
            <Row gutter={0} style={{ marginTop: '10px' }}>
              <Col span={12}>
                <Table
                  title={() => 'Nitriding History'}
                  columns={nitridingColumns}
                  dataSource={nitridingData}
                  pagination={false}
                  className="custom-nitri-table px-0"
                />
              </Col>
              <Col span={12}>
                <Table
                  title={() => 'Nitriding History'}
                  columns={nitridingColumns}
                  dataSource={nitridingData}
                  pagination={false}
                  className="custom-nitri-table px-0"
                />
              </Col>
            </Row>
            <Table
              title={() => 'Extrusion Data'}
              columns={extrusionColumns}
              dataSource={extrusionData}
              pagination={false}
              className="custom-nitri-table px-0"
            />
          </div>
    </>
        
     
  );
}

export default DieLifeCard;
